
        <div class="">
          <!-- Load the respective policy component dynamically -->
          <ng-container *ngIf="selectedComponent">
            <ng-container *ngComponentOutlet="selectedComponent"></ng-container>
          </ng-container>
        </div>
